import styled, { css } from "styled-components";
import { Button, Input, Form } from "global/styles/styles.js";
const S = {};

const SessionExtensionWrapperBackgroundColor = ({theme: { $sessionExtensionWrapperBackgroundColor }}) => `${$sessionExtensionWrapperBackgroundColor}`;
const SessionExtensionWrapperTextColor = ({theme: { $sessionExtensionWrapperTextColor }}) => `${$sessionExtensionWrapperTextColor}`;
const SessionExtensionTopRowBackgroundColor = ({theme: { $sessionExtensionTopRowBackgroundColor }}) => `${$sessionExtensionTopRowBackgroundColor}`;
const SessionExtensionTopRowDistinctiveTextColor = ({theme: { $sessionExtensionTopRowDistinctiveTextColor }}) => `${$sessionExtensionTopRowDistinctiveTextColor}`;
const SessionExtensionMainMessageTextColor = ({theme: { $sessionExtensionMainMessageTextColor }}) => `${$sessionExtensionMainMessageTextColor}`;

const sessionExtensionBalanceLabelColorText = ({ theme: { $sessionExtensionBalanceLabelColorText } }) => `${$sessionExtensionBalanceLabelColorText}`;
const sessionExtensionBalanceBackgroundColor = ({ theme: { $sessionExtensionBalanceBackgroundColor } }) => `${$sessionExtensionBalanceBackgroundColor}`;
const sessionExtensionBalanceTextColor = ({ theme: { $sessionExtensionBalanceTextColor } }) => `${$sessionExtensionBalanceTextColor}`;

const sessionExtensionButtonsContainerBorderColor = ({theme: { $sessionExtensionButtonsContainerBorderColor }}) => `${$sessionExtensionButtonsContainerBorderColor}`;
const sessionExtensionButtonTextColor = ({ theme: { $sessionExtensionButtonTextColor } }) => `${$sessionExtensionButtonTextColor}`;
const sessionContinueButtonBackgroundColor = ({theme: { $sessionContinueButtonBackgroundColor }}) => `${$sessionContinueButtonBackgroundColor}`;
const sessionExtensionLeaveButtonBackgroundColor = ({theme: { $sessionExtensionLeaveButtonBackgroundColor }}) => `${$sessionExtensionLeaveButtonBackgroundColor}`;
const sessionExtensionReLoginButtonBackgroundColor = ({theme: { $sessionExtensionReLoginButtonBackgroundColor }}) => `${$sessionExtensionReLoginButtonBackgroundColor}`;
const sessionExtensionConfirmButtonBackgroundColor = ({theme: { $sessionExtensionConfirmButtonBackgroundColor }}) => `${$sessionExtensionConfirmButtonBackgroundColor}`;

const ErrorTextColor = ({theme: { $sessionExtensionErrorTextColor }}) => `${$sessionExtensionErrorTextColor}`;

const sessionExtensionInputBackgroundColor = ({theme: { $sessionExtensionInputBackgroundColor }}) => `${$sessionExtensionInputBackgroundColor}`;
const sessionExtensionInputTextColor = ({theme: { $sessionExtensionInputTextColor}}) => `${$sessionExtensionInputTextColor}`;
const sessionExtensionInputBorderColor = ({theme: { $sessionExtensionInputBorderColor}}) => `${$sessionExtensionInputBorderColor}`;

const sessionExtensionCounterTextColor = ({theme: { $sessionExtensionCounterTextColor }}) => `${$sessionExtensionCounterTextColor}`;

S.SendSmsCodeForm = styled(Form)`
  width: 100%;
`;

S.MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

S.SessionExtensionWrapper = styled.div`
  width: calc(100%-2px);
  display: flex;
  padding: 1rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${SessionExtensionWrapperBackgroundColor};
  color: ${SessionExtensionWrapperTextColor};

  &.padding-top {
    padding-top: 4rem;
  }
`;

S.TimerIcon = styled.div`
  width: calc(25px);
  height: calc(25px);
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

S.SessionExtensionTopRow = styled.div`
  background-color: ${SessionExtensionTopRowBackgroundColor};
  padding: 0.5rem 1.5rem 0.5rem 1.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

S.TopRowLeftSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center
`;

S.TopRowRightSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center
`;

S.SessionDeactive = styled.span`
  text-transform: uppercase;
  font-weight: 600;
`;

S.SessionExtensionUserDetails = styled.span`
  color: ${SessionExtensionTopRowDistinctiveTextColor};
  text-transform: uppercase;
  font-weight: 600;
`;

S.SessionExtensionUserMobile = styled.span`
  color: ${SessionExtensionTopRowDistinctiveTextColor};
  text-transform: none;
  font-weight: 600;
`;

S.SessionExtensionHighlightedMessage = styled.div`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
`;

S.SessionExtensionMainMessage = styled.div`
  margin-top: 2rem;
  margin-bottom: 3rem;
  text-align: center;
  padding: 0 25% 0 25%;
  font-size: 14px;
  color: ${SessionExtensionMainMessageTextColor};
`;

S.ButtonsTopBorder = styled.div`
  background-color: ${sessionExtensionButtonsContainerBorderColor};
  opacity: 0.3;
  width: 100%;
  height: 1px;
`;

S.ButtonsContainer = styled.div`
  width: 100%;
  padding-top: 1rem;
  display: flex;
  justify-content: space-between;
`;

S.ButtonAction = styled(Button)`
  border: 0px;
  border-radius: 20px;
  height: 2.5rem;
  line-height: 2.5rem;
  width: 49%;
  color: ${sessionExtensionButtonTextColor};
  text-transform: uppercase;
  font-size: 14px;
  text-align: center;

  &.continue {
    background-color: ${sessionContinueButtonBackgroundColor};
  }

  &.leave {
    background-color: ${sessionExtensionLeaveButtonBackgroundColor};
  }

  &.reLogin {
    background-color: ${sessionExtensionReLoginButtonBackgroundColor};
  }

  &.confirm {
    background-color: ${sessionExtensionConfirmButtonBackgroundColor};
    margin: auto;
  }
`;

S.BalanceLabel = styled.span`
  color: ${sessionExtensionBalanceLabelColorText};
  text-transform: uppercase;
  margin-right: 1rem;
  font-weight: 600; 
`;

S.BalanceBackground = styled.div`
  width: 9.5rem;
  height: 2rem;
  line-height: 2rem;
  text-align: right;
  padding-right: 0.5rem;
  border-radius: 4px;
  background-color: ${sessionExtensionBalanceBackgroundColor};
  color: ${sessionExtensionBalanceTextColor};
`;

S.SessionExtensionPutSmsCodeMessage = styled.div`
  margin-top: 2rem;
  margin-bottom: 1rem;
  text-align: center;
  padding: 0 5% 0 5%;
  font-size: 14px;
  color: ${SessionExtensionMainMessageTextColor};
`;

S.InputContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
`;

S.InputWrapper = styled.div`
  width: 60%;
  margin-left: auto;
  display: flex;
  flex-direction: column;
`;

S.SmsCodeInput = styled(Input)`
    font-size: 17px;
    font-weight: bold;
    text-align: right;
    padding: 0.5rem 1rem 0.5rem 1rem;
    background-color: ${sessionExtensionInputBackgroundColor};
    color: ${sessionExtensionInputTextColor};
    border: 1px solid ${sessionExtensionInputBorderColor};
`;

S.ErrorMessage = styled.div`
  text-align: right;
  color: ${ErrorTextColor};
  font-size: 12px;
`;

S.SendAgainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`;

S.Counter = styled.div`
  font-size: 2rem;
  color: ${sessionExtensionCounterTextColor};
  margin-left: auto;
  &.visibility-hidden {
    visibility: hidden;
  }
`;

S.ResendSmsCode = styled(Button)`
    width: 9.5rem;
    height: 2rem;
    line-height: 2rem;
    text-align: right;
    padding-right: 0.5rem;
    border-radius: 4px;
    background-color: ${sessionExtensionBalanceBackgroundColor};
    color: ${sessionExtensionBalanceTextColor};
    margin-left: 1rem;
    margin-top: 5px;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 13px;
    text-align: center;
    opacity: 1.0;
    &[disabled]{
      opacity: 0.1;
    }
`;



export default S;
